/**
 *
 * Asynchronously loads the component for SlideFilter
 *
 */
import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
